import { useMemo, useCallback } from 'react';
import { useRouteMatch, Route, useHistory } from 'react-router';
import noop from 'lodash/noop';
import { setDisplayName } from 'lib/utils';

interface Options {
  onCloseIteraction?: (...args: any) => any;
}

export const useRoutableModal = (modalPathStub: string, { onCloseIteraction = noop }: Options = {}) => {
  const { url } = useRouteMatch();
  const { replace } = useHistory();
  const path = `${url}/${modalPathStub}`;

  const closeModal = useCallback(() => {
    replace(url);
    onCloseIteraction();
  }, [onCloseIteraction, replace, url]);

  const RoutableModalWrapper = useMemo(
    () => setDisplayName('RoutableModalWrapper', ({ children }) => <Route path={path} render={() => children} />),
    [path],
  );

  return {
    path,
    props: { isOpen: true, onRequestClose: closeModal },
    RoutableModalWrapper,
  };
};
